import React from 'react';

import styles from './userProfileSectionHeaderStyles';

import Icon from 'buyside/components/presentation/Icon/icon';
import ProfileSectionVisibilityTag from 'buyside/components/presentation/ProfileSectionVisibilityTag/profileSectionVisibilityTag';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import EyeIcon from 'SVGs/eye';
import BriefcaseIcon from 'buyside/svgs/briefcase.svg';
import PencilIcon from 'buyside/svgs/pencil.svg';

import { HIRING_MANAGER, ADMIN } from 'buyside/util/userProfileConstants';

const UserProfileSectionHeader = ({
  icon,
  title,
  sectionVisibility,
  openEditModal,
  roleIsAdmin
}) => {
  return (
    <div className={styles.sectionHeader}>
      <div className={styles.sectionHeaderHeading}>
        <Icon type={icon} />
        <span>{title}</span>
        {sectionVisibility === ADMIN && (
          <ProfileSectionVisibilityTag icon={EyeIcon} visibility="You" />
        )}
        {sectionVisibility === HIRING_MANAGER && (
          <ProfileSectionVisibilityTag icon={BriefcaseIcon} visibility="Hiring Managers" />
        )}
      </div>
      <div>
        {roleIsAdmin && openEditModal && (
          <Button
            text="Edit"
            onClick={openEditModal}
            className={styles.sectionHeaderEditButton}
            type={BUTTON_TYPES.LINK}
            icon={PencilIcon}
            iconStyle={styles.editButtonIcon}
          />
        )}
      </div>
    </div>
  );
};

export default UserProfileSectionHeader;
